module.exports = __webpack_public_path__ + "img/6.356135e8.png";